import React from 'react';
import { Star } from '@mui/icons-material';
import { Link, useNavigate } from 'react-router-dom';
import './Dashboard.css';
import BrokerCard from '../../authentication/simple/BrokerCard';
import paisa from '../../../assets/img/login-img/5paisa.webp';
import firstock from '../../../assets/img/login-img/firstock.png';
import Background from '../../common/Background';
import Cardimg3 from "../../../assets/img/illustrations/corner-5.png";

const PreferredBrokersCard = () => {
  const navigate = useNavigate();
  return (
    <Background image={Cardimg3} className="bg-card">
      <div className="section-content">
        <div className="pref-section-header">
          <h2 className="pref-section-title">Preferred Brokers</h2>
          <span className="section-subtitle">Connect or switch to our recommended brokers</span>
    </div>
          <div className="brokers-grid">
            <BrokerCard
              logoSrc={paisa}
              name="5Paisa"
              status="Analysis only"
              onClick={() => window.open('https://www.5paisa.com/demat-account?ReferralCode=57003172&ReturnUrl=invest-open-account', '_blank')}
            />
            <BrokerCard
              logoSrc={firstock}
              name="Firstock"
              status="Analysis only"
              onClick={() => window.open('https://signup.firstock.in/?p=FNO99', '_blank')}
            />
          </div>
          <div className="important-note">
            <ul>
              <li>Once your account is opened successfully through the above link, please reach us on whatsapp to enable free access to all our QuikTrade products.</li>
            </ul>
          </div>
      </div>
    </Background>
  );
};

export default PreferredBrokersCard;


